"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionParser = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const bignumber_js_1 = require("bignumber.js");
const ethers_1 = require("ethers");
const types_1 = require("../../types");
const utils_1 = require("../../utils");
const foxy = __importStar(require("./foxy"));
const thor = __importStar(require("./thor"));
const uniV2 = __importStar(require("./uniV2"));
const utils_2 = require("./utils");
const weth = __importStar(require("./weth"));
const yearn = __importStar(require("./yearn"));
const zrx = __importStar(require("./zrx"));
class TransactionParser {
    constructor(args) {
        this.chainId = args.chainId;
        this.assetId = (0, caip_1.toAssetId)({
            ...(0, caip_1.fromChainId)(this.chainId),
            assetNamespace: 'slip44',
            assetReference: caip_1.ASSET_REFERENCE.Ethereum
        });
        const provider = new ethers_1.ethers.providers.JsonRpcProvider(args.rpcUrl);
        this.thor = new thor.Parser({ chainId: this.chainId, rpcUrl: args.rpcUrl });
        this.uniV2 = new uniV2.Parser({ chainId: this.chainId, provider });
        this.zrx = new zrx.Parser();
        this.yearn = new yearn.Parser({ provider, chainId: this.chainId });
        this.foxy = new foxy.Parser();
        this.weth = new weth.Parser({ chainId: this.chainId, provider });
        this.parsers = [this.zrx, this.thor, this.uniV2, this.yearn, this.foxy, this.weth];
    }
    // return any addresses that can be detected
    getInternalAddress(inputData) {
        switch ((0, utils_2.getSigHash)(inputData)) {
            case this.thor.supportedFunctions.transferOutSigHash:
                return this.thor.getInternalAddress(inputData);
            case utils_2.SENDMULTISIG_SIG_HASH:
                return (0, utils_2.getInternalMultisigAddress)(inputData);
            default:
                return;
        }
    }
    async parse(tx, address, internalTxs) {
        var _a;
        // We expect only one Parser to return a result. If multiple do, we take the first and early exit.
        const contractParserResult = await (0, utils_1.findAsyncSequential)(this.parsers, async (parser) => await parser.parse(tx));
        const parsedTx = {
            address,
            blockHash: tx.blockHash,
            blockHeight: tx.blockHeight,
            blockTime: tx.blockTime,
            chainId: this.chainId,
            confirmations: tx.confirmations,
            status: TransactionParser.getStatus(tx),
            trade: contractParserResult === null || contractParserResult === void 0 ? void 0 : contractParserResult.trade,
            transfers: (_a = contractParserResult === null || contractParserResult === void 0 ? void 0 : contractParserResult.transfers) !== null && _a !== void 0 ? _a : [],
            txid: tx.txid,
            data: contractParserResult === null || contractParserResult === void 0 ? void 0 : contractParserResult.data
        };
        return this.getParsedTxWithTransfers(tx, parsedTx, address, internalTxs);
    }
    static getStatus(tx) {
        var _a;
        const status = (_a = tx.ethereumSpecific) === null || _a === void 0 ? void 0 : _a.status;
        if (status === -1 && tx.confirmations <= 0)
            return types_1.Status.Pending;
        if (status === 1 && tx.confirmations > 0)
            return types_1.Status.Confirmed;
        if (status === 0)
            return types_1.Status.Failed;
        return types_1.Status.Unknown;
    }
    getParsedTxWithTransfers(tx, parsedTx, address, internalTxs) {
        var _a, _b, _c, _d, _e, _f;
        const sendAddress = (_b = (_a = tx.vin[0].addresses) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '';
        const receiveAddress = (_d = (_c = tx.vout[0].addresses) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '';
        if (address === sendAddress) {
            // send amount
            const sendValue = new bignumber_js_1.BigNumber(tx.value);
            if (sendValue.gt(0)) {
                parsedTx.transfers = (0, utils_1.aggregateTransfer)(parsedTx.transfers, types_1.TransferType.Send, this.assetId, sendAddress, receiveAddress, sendValue.toString(10));
            }
            // network fee
            const fees = new bignumber_js_1.BigNumber((_e = tx.fees) !== null && _e !== void 0 ? _e : 0);
            if (fees.gt(0)) {
                parsedTx.fee = { assetId: this.assetId, value: fees.toString(10) };
            }
        }
        if (address === receiveAddress) {
            // receive amount
            const receiveValue = new bignumber_js_1.BigNumber(tx.value);
            if (receiveValue.gt(0)) {
                parsedTx.transfers = (0, utils_1.aggregateTransfer)(parsedTx.transfers, types_1.TransferType.Receive, this.assetId, sendAddress, receiveAddress, receiveValue.toString(10));
            }
        }
        (_f = tx.tokenTransfers) === null || _f === void 0 ? void 0 : _f.forEach((transfer) => {
            // FTX Token (FTT) name and symbol was set backwards on the ERC20 contract
            if (transfer.token === '0x50D1c9771902476076eCFc8B2A83Ad6b9355a4c9') {
                transfer.name = transfer.symbol;
                transfer.symbol = transfer.name;
            }
            const token = {
                contract: transfer.token,
                decimals: transfer.decimals,
                name: transfer.name,
                symbol: transfer.symbol
            };
            const transferArgs = [
                (0, caip_1.toAssetId)({
                    ...(0, caip_1.fromChainId)(this.chainId),
                    assetNamespace: 'erc20',
                    assetReference: transfer.token
                }),
                transfer.from,
                transfer.to,
                transfer.value,
                token
            ];
            // token send amount
            if (address === transfer.from) {
                parsedTx.transfers = (0, utils_1.aggregateTransfer)(parsedTx.transfers, types_1.TransferType.Send, ...transferArgs);
            }
            // token receive amount
            if (address === transfer.to) {
                parsedTx.transfers = (0, utils_1.aggregateTransfer)(parsedTx.transfers, types_1.TransferType.Receive, ...transferArgs);
            }
        });
        internalTxs === null || internalTxs === void 0 ? void 0 : internalTxs.forEach((internalTx) => {
            const transferArgs = [
                (0, caip_1.toAssetId)({
                    ...(0, caip_1.fromChainId)(this.chainId),
                    assetNamespace: 'slip44',
                    assetReference: caip_1.ASSET_REFERENCE.Ethereum
                }),
                internalTx.from,
                internalTx.to,
                internalTx.value
            ];
            // internal eth send
            if (address === internalTx.from) {
                parsedTx.transfers = (0, utils_1.aggregateTransfer)(parsedTx.transfers, types_1.TransferType.Send, ...transferArgs);
            }
            // internal eth receive
            if (address === internalTx.to) {
                parsedTx.transfers = (0, utils_1.aggregateTransfer)(parsedTx.transfers, types_1.TransferType.Receive, ...transferArgs);
            }
        });
        return parsedTx;
    }
}
exports.TransactionParser = TransactionParser;
